import { Navigate } from 'react-router-dom';

// Backend role strings aren't always consistently cased ("Sales Manager" vs "sales manager",
// "GRE" vs "gre") — compare case-insensitively so a casing difference doesn't lock a legitimate
// user out of their own pages.
export const RoleGuard = ({ allowedRoles, children }) => {
  const user = localStorage.getItem('role');
  const normalizedUser = user?.trim().toLowerCase();
  const hasAccess = normalizedUser && allowedRoles.some((role) => role.trim().toLowerCase() === normalizedUser);

  if (!hasAccess) {
    return <Navigate to="/vms/unauthorized" />; // Redirect to an unauthorized page or any fallback route
  }
  return children; // Render the child component if access is allowed
};
